"use client";

import { CreateOrUpdateCertificate } from "components/ui/v2/certificates/bundle/Certificates/Forms/CreateOrUpdateCertificate";
import type { ReactNode } from "react";

export const CERTIFICATE_FORM_ID = "certificate-form";

export interface CertificateCreateModalContentV2Props {
  onClose: () => void;
  hideHeader?: boolean;
  hideFooter?: boolean;
  formId?: string;
  onFooterChange?: (footer: ReactNode) => void;
}

export function CertificateCreateModalContentV2({
  onClose,
  hideHeader = true,
  hideFooter = false,
  formId = CERTIFICATE_FORM_ID,
  onFooterChange,
}: CertificateCreateModalContentV2Props) {
  return (
    <CreateOrUpdateCertificate
      onClose={onClose}
      hideHeader={hideHeader}
      hideFooter={hideFooter}
      formId={formId}
      onFooterChange={onFooterChange}
    />
  );
}
